export const DIRECTION = {
  ltr: 'ltr',
  rtl: 'rtl',
};
